function Toogle({
  id, name, checked, leftStatus, rightStatus, ...props
}) {
  return (
    <div className="button r" id={id} style={{ width: '100px', height: '28px' }}>
      <input
        type="checkbox"
        className="checkbox"
        name={name}
        checked={checked}
        {...props}
      />
      <div className="knobs">
        <span className="knobs-text">{checked ? rightStatus : leftStatus}</span>
      </div>
      <div className="layer" />
    </div>
  );
}

export default Toogle;
